<template>
  <nuxt-link
    class="c-nav-card"
    :class="{
      'c-nav-card--new': navItem.new
    }"
    :to="navItem.linkUrl"
  >
    <template v-if="navItem">
      <div
        class="c-nav-card__wrapper"
        :class="[
          'l-flex',
          'l-flex__nowrap',
          'u-overflow-hidden',
        ]"
      >
        <div class="c-nav-card__image-wrapper">
          <img
            v-if="navItem.image"
            class="c-nav-card__image"
            :src="navItem.image.src"
            :alt="navItem.image.alt"
          >
        </div>
        <div
          class="c-nav-card__copy"
          :class="[
            'l-flex--grow',
            'u-overflow-hidden',
          ]"
        >
          <header
            class="c-nav-card__header"
            :class="['t-heading-6', 'u-margin-bottom-xx-small']"
          >
            {{ navItem.title }}
          </header>
          <header
            v-if="navItem.subtitle && navItem.subtitle.length > 0"
            class="c-nav-card__subheader"
            :class="{
              'c-nav-card__subheader--accent': navItem.highlightSubtitle,
              't-heading-13': true,
              't-heading-13--light': true,
              'u-margin-bottom-xx-small': true,
            }"
          >
            {{ navItem.subtitle }}
          </header>
          <p
            v-if="navItem.description"
            class="c-nav-card__description"
            :class="['t-paragraph-small', 't-paragraph-small—x-light']"
          >
            {{ navItem.description }}
          </p>
        </div>
      </div>
    </template>
  </nuxt-link>
</template>

<script>


export default {
  name: "NavCard",
  props:{
    navItem: {
      type: Object,
      default: () => ({}),
    }
  },
}
</script>
<style lang="scss" scoped>
  .c-nav-card {
    padding: rem(4px) rem(19px);
    cursor: pointer;
    display: block;
    text-decoration: none;

    &--new {
      background-image: url("~@/assets/images/new_badge_blue.png");
      background-repeat: no-repeat;
      background-position: right rem(10px) top rem(10px);
      background-size: rem(47px) rem(20px);
    }

    &__wrapper {
      overflow: hidden;
      width: 100%;
    }

    &__header {
      margin-top: rem(11px);
      padding-right: rem(40px);
    }

    &__copy {
      align-self: baseline;
      padding-left: rem(30px);
    }

    @include themify($themes) {
      background-color: themed("background", "xx-light");
      color: themed("foreground", "base");
    }

    &__image {
      width: rem(122px);
    }

    &__subheader {
      text-transform: uppercase;
      &--accent {
        @include themify($themes) {
          color: themed("accent", "base");
        }
      }
    }

    &__description {
      @include themify($themes) {
        color: themed("foreground", "light-text");
      }
    }

    &:hover {
      .c-nav-card__header {
        @include themify($themes) {
          color: themed("accent", "base");
        }
      }
    }
  }
</style>
